function getTabables() {
  const selector = `
    input:not([type=hidden]),
    select,
    textarea,
    button,
    a[href]
  `
  /* 
   * fetch all 
   * input:not([type=hidden]),
   * select,
   * textarea,
   * button,
   * a[href]
   */
  let tabables = document.querySelectorAll(selector);

  /* 
   * remove the elements that either has 
   * disabled
   * or,
   * tabindex=-1
   * attribute
   */
  
  tabables = Array.from(tabables).filter((tabable) => {
    const isDisabled = tabable.hasAttribute('disabled');
    const isNegativeTabIndexed = tabable.getAttribute('tabindex') === "-1";
    if (isDisabled || isNegativeTabIndexed) {
      return;
    }
    return tabable;
  });
  
  return tabables;
}

document.addEventListener('DOMContentLoaded', function() {
  // mobile toggle
  const siteHeader = document.querySelector('#site-header');
  const mobileToggle = document.querySelector('.mobile-toggle-button');
  let animatingHeaderItem = false;
  let animatingHeaderItemTimeout = false;

  mobileToggle.addEventListener('click', function() {
    siteHeader.classList.toggle('mobile-open');

    if (siteHeader.classList.contains('mobile-open')) {
      mobileToggle.setAttribute('aria-expanded', 'true');
      mobileToggle.setAttribute('aria-label', 'Close menu');
    } else {
      mobileToggle.setAttribute('aria-expanded', 'false');
      mobileToggle.setAttribute('aria-label', 'Open menu');
    }
  })

  // mobile menu accordions
  const mobileAccordions = Array.from(siteHeader.querySelectorAll('.navbar-accordion-button'));
  siteHeader.querySelector('#site-navigation').addEventListener('keydown', handleMenuKeyboardInteraction);
  function handleMenuKeyboardInteraction(event) {
    const menu = siteHeader.querySelector('#site-navigation');
    const openMenuKeys = ['Enter', ' ']; 
    const closeMenuKeys = ['Escape'];
    const navigateKeys = ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'];
    const allKeys = openMenuKeys.concat(closeMenuKeys, navigateKeys);
    if (!event || !event.key || !allKeys.includes(event.key)) {
      return;
    }

    const currentFocus = document.activeElement;

    if (closeMenuKeys.includes(event.key)) {
      let accordion = (currentFocus.nodeName === 'BUTTON') ? currentFocus : currentFocus.closest('.menu-item-has-children').querySelector('.navbar-accordion-button');
      if(accordion) {
        closeAccordion(accordion);
      }
      return;
    }

    if (openMenuKeys.includes(event.key)) {
      let accordion = (currentFocus.nodeName === 'BUTTON') ? currentFocus : currentFocus.closest('.menu-item-has-children').querySelector('.navbar-accordion-button');
      if(accordion) {
        const submenu = accordion.nextElementSibling;
        const children = submenu.querySelectorAll('a');
        setTimeout(() => {
          if(submenu && children && accordion.getAttribute('aria-expanded') !== 'false') {
            children[0].focus();
          }
        }, 50);
      }
      return;
    }

    if(navigateKeys.includes(event.key)) {
      if ( event.key === 'ArrowDown' || event.key === 'ArrowUp' ) {
        event.preventDefault();
        if(currentFocus.nodeName === 'BUTTON' && currentFocus.classList.contains('navbar-accordion-button')) {
          let accordion = (currentFocus.nodeName === 'BUTTON') ? currentFocus : currentFocus.closest('.navbar-accordion-button');
          if(accordion) {
            const submenu = accordion.nextElementSibling;
            const children = submenu.querySelectorAll('a');
            accordion.click();
            if(accordion.getAttribute('aria-expanded') !== 'false') {
              children[0].focus();
            }
          }
        } else if(currentFocus.nodeName === 'A' && currentFocus.classList.contains('sub-menu-item')) {
          const children = Array.from(currentFocus.closest('.sub-menu').querySelectorAll('a.sub-menu-item'));
          const currentIndex = children.findIndex((child) => child === currentFocus);
          const nextIndex = event.key === 'ArrowDown' ? currentIndex + 1 : currentIndex - 1;
          const nextChild = children[nextIndex] ?? children[0];
          nextChild.focus();
        }
      }
      if ( event.key === 'ArrowLeft' || event.key === 'ArrowRight' ) {
        event.preventDefault();
        let currentNavItem = currentFocus.closest('.primary-menu-item');
        const navItems = Array.from(document.querySelectorAll('.primary-menu-item'));
        const currentIndex = navItems.findIndex((child) => child === currentNavItem);
        const nextIndex = event.key === 'ArrowRight' ? currentIndex + 1 : currentIndex - 1;
        if(nextIndex < 0 || nextIndex >= navItems.length) {
          return;
        }
        const nextItem = navItems[nextIndex];
        nextItem.querySelector('a,button').focus();

      }
    }
  }

  function handleAccordionInteraction(accordion, eventType, event = false) {
    const menuitem = accordion.parentNode;
    const submenu = accordion.nextElementSibling;
    if ((eventType === 'mouseover' || eventType === 'mouseenter' || eventType === 'mouseexit') && window.innerWidth < 1000) {
      return;
    }
    if (animatingHeaderItem === menuitem && animatingHeaderItemTimeout !== false) {
      return;
    }
    animatingHeaderItem = menuitem;
    animatingHeaderItemTimeout = true;
    if(siteHeader.querySelectorAll('.primary-menu-item.open').length > 0) {
      siteHeader.querySelectorAll('.primary-menu-item.open').forEach((item) => {
        if(item !== menuitem) {
          closeAccordion(item.querySelector('.navbar-accordion-button'));
        }
      });
    }
      
    menuitem.classList.toggle('open');
  
    if (menuitem.classList.contains('open')) {
      accordion.setAttribute('aria-expanded', 'true');
      submenu.setAttribute('aria-hidden', 'false');
      if (window.innerWidth < 1000) {
        menuitem.style.height = 40 + submenu.scrollHeight + 'px';
      }
    } else {
      accordion.setAttribute('aria-expanded', 'false');
      submenu.setAttribute('aria-hidden', 'true');
      if (window.innerWidth < 1000) {
        menuitem.style.height = 40 + 'px';
      }
    }
    setTimeout(() => {
      animatingHeaderItemTimeout = false;
    }, 50);
  }
  
  function closeAccordion(accordion) {
    const menuitem = accordion.parentNode;
    const submenu = accordion.nextElementSibling;
    menuitem.classList.remove('open');
    accordion.setAttribute('aria-expanded', 'false');
    submenu.setAttribute('aria-hidden', 'true');
    if (window.innerWidth < 1000) {
      menuitem.style.height = 40 + 'px';
    }
  }

  mobileAccordions.forEach(function(accordion) {
    accordion.addEventListener('click', function() {
      handleAccordionInteraction(accordion, 'click');
    });
  
    
    accordion.parentNode.addEventListener('mouseenter', function() {
      handleAccordionInteraction(accordion, 'mouseenter');
    });

    accordion.parentNode.addEventListener('mouseleave', function() {
      handleAccordionInteraction(accordion, 'mouseenter');
    });
  });

  // on resize, remove any open classes on menu items
  window.addEventListener('resize', function() {
    mobileAccordions.forEach(function(accordion) {
      const menuitem = accordion.parentNode;
      const submenu = accordion.nextElementSibling;

      menuitem.classList.remove('open');
      accordion.setAttribute('aria-expanded', 'false');
      if (submenu) {
        submenu.setAttribute('aria-hidden', 'true');
      }
      menuitem.style.height = 40 + 'px';
    });
  });
  

  // auth changes
  const userID = window.localStorage.getItem('ajs_user_id');
  if (userID && userID !== 'null' && userID !== 'undefined') {
    siteHeader.classList.add('authenticated');
  }
})